export default __webpack_public_path__ + "static/media/ie.2cb766a2.svg";